export default {
  EXPORTUSERTEMPLATE: "/user/export/excel/template",
  IMPORTUSERTEMPLATE: "/user/import/excel/template",
  SYSTEMPARAM: "/user/systemParam", // 获取系统参数
  LANGMODULE: "/multiLang/module",
  USER: "/user", //用户信息
  USEREDIT: "/user/id", // 根据UID查询用户信息
  WHS: "/user/whs", // 获取所有warehouse
  USERRESETCHANGES: "/user/resetChanges",
  PROJECT: "/user/project", // 获取所有project
  DELETEPROJECT: "/user/delete/project", // 删除ROJECT
  USERDELETEWHS: "/user/delete/whs",
  USERSTAS: "/user/status", // 更改用户状态
  USERPERMISSION: "/permission", // 根据roleUid或userUid查询Permission
  USERROLE: "/user/role", //查询所有Role名及Uid
  CHANGELANG: "/user/defaultLang",// 更换用户默认语言
  ROLEFETCH: "/role/fetch", // 分页查询所有角色或关键字分页查询
  ROLE: "/role", // 添加角色/修改角色
  TYPEANDPERM: "/role/typeAndPerm", // 添加角色页面获取RoleType及Permission
  FINDONE: "/role/findOne", // 根据UID查询角色信息
  DELETEROLE: "/role/delete", // 删除角色
  USERLOGIN: "/user/login", // 是否注册
  TIMEZONE: "/user/timeZone", // timezone 下拉数据
  INFEOTABLEMSG: "/inventory/msg", // 消息提示表格数据
  MSGCONTENT: "/inventory/msgContent", // info detail
  GETMSGBYORDER: "/inventory/msgByOrder", // info detail
  GETUSERADDRESS: "/user/address", // 获取城市
  USERINVITECODE: "/user/inviteCode",
  GENERICPROJECTINFO: "/generic/project/info", // 获取用户设置的小数位
  USERALLLOGINACCOUNT: "/user/all/loginAccount",
  UAERLOGINLOGINACCOUNT: "/user/login/loginAccount",
  USERLOGOUTLOGINACCOUNT: "/user/logout/loginAccount",
  RELEASENOTES: "/user/releaseNotes",
  DOWNLOADRELEASENOTES: "/user/downloadReleaseNotes",
  USERORGCODE: "/user/orgCode",
  MARKUSERPROJECTCODE: "/user/projectCode",
  CURRENTUSERPROJECT: "/user/currentProject",
  MARKUSERALLLOGINACCOUNT: "/user/all/loginAccount",
  PRINTNODEWARHOUSE: "/generic/printNode/warehouse",
  PRINTNODEPROFILENAME: "/generic/printNode/profileName",
  PRINTNODEUNIQUENAME: "/generic/printNode/uniqueName",
  PRINTNODEPOP: "/generic/printNode/pop",
  HENERICUSERGMCTABLE: "/generic/user/gmcTable",
  GENERICUSERLIST: "/generic/user/list",
  GENERICPROJECTLIST: "/generic/project/list",
  GENERICUSERGMC: "/generic/user/gmc",
  GENERICUSERGMCEDIT: "/generic/user/gmc/edit",
  USERDISPLAYABLEFIELD: "/generic/user/displayableField",
  GENERICUSERGMCDETAIL: "/generic/user/gmc/detail",
  BATCHUPDATESHIPMENT: "/generic/batchUpdate/shipment",
  USERSENDEMAIL: "/user/sendEmail",
  USERSIGNUP: "/user/signup",
  USERCHANGEPWD: "/user/changePwd",
  USERCHANGEPWD2: "/user/changePwd2",
  USERRESETPASSWORDS: "/user/resetPasswords",
  PACKSCANWGTUOM: "/pack/scan/wgtUom",
  CHANGEALIASNAME: "/user/changeAliasName",
  USERDELETEORG: "/user/delete/org",
  USERBATCHUPDATE: "/user/batchUpdate",
  USERROLUUID: "/user/roleUid",
  USERUNAUTHUASER: "/user/unauth/user",
  USERREMOVEROLE: "/user/remove/role",
  USERORG: "/user/org",
  USERORGAddLIST: "/user/org",
  TMSSHIPMENTFROM: "/tms/shipmentForm",
  USERALLPROJECT: "/user/all/project",
  GETUSERLISTBYORGCODE:"/user/getUserListByOrgCode",
  MOOSECLEAN:"/moose/clean",
  MOOSEQUERY:"/moose/query",
  GETAUTHENTICATORQR:"/user/getAuthenticatorQR",
  VERIFYQR:"/user/verifyQR",
};
